// <auto-generated />
// Source: Contracts/client-routes.json
// Run: npm run generate:client-routes

export const ClientRoutes = {
  invitationList: {
    path: "/user/invitations",
    get(): string { return "/user/invitations"; },
  },
  invitation: {
    path: "/user/invitations/:invitationCode",
    get(invitationCode: string): string { return "/user/invitations/" + encodeURIComponent(invitationCode); },
  },
  emailConfirmation: {
    path: "/confirm-email",
    get(code: string): string { return "/confirm-email?code=" + encodeURIComponent(code); },
  },
  emailConfirmationPending: {
    path: "/confirm-email/pending",
    get(): string { return "/confirm-email/pending"; },
  },
  passwordReset: {
    path: "/reset-password",
    get(code: string): string { return "/reset-password?code=" + encodeURIComponent(code); },
  },
} as const;
